'use client'

import { SKUSelectionErrorMessageDefaults } from '@src/components/SKUSelectionErrorMessage/SKUSelectionErrorMessage.defaults'
import type { SKUSelectionErrorMessageProps } from '@src/components/SKUSelectionErrorMessage/SKUSelectionErrorMessage.props'
import { isSelectionStateValid, useSKUSelectionStore } from '@src/stores/SKUSelectionStore'

export const SKUSelectionErrorMessage = (
  props: SKUSelectionErrorMessageProps = SKUSelectionErrorMessageDefaults
) => {
  const { errorMessage } = props
  const groups = useSKUSelectionStore((state) => state.groups)
  const groupRestrictions = useSKUSelectionStore((state) => state.groupRestrictions)

  const isValid = isSelectionStateValid(groups, groupRestrictions)

  if (isValid) return null

  return (
    <div className="text-body-md" dangerouslySetInnerHTML={{ __html: errorMessage ?? '' }}></div>
  )
}
